/* eslint-disable vue/no-unused-components */
<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="box column is-6 is-offset-3" id="login-box">
          <h1 class="title has-text-centered">ຟອມສະໝັກນັກສຶກສາ ທີ່ສົນໃຈຝຶກງານ</h1>
          <h1 v-if="false" class="title is-5 has-text-centered">Form</h1>
          <div class="columns">
            <div class="column is-8 is-offset-2">
              <div class="field">
                <div class="control">
                  <label class="label">ຊື່ ແລະ ນາມສະກຸນ:</label>
                  <input type="text" class="input" v-model="fullname" />
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">ເພດ:</label>
                  <Multiselect
                      placeholder="ເລືອກ"
                      v-model.trim="gender"
                      label="TITLE"
                      track-by="ID"
                      :options="genderlist"
                    >
                    </Multiselect>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">ສາຂາຮຽນ:</label>
                  <input type="text" class="input" v-model="section" />
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">ປີຮຽນ:</label>
                  <input type="number" class="input" v-model="year" />
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">ເບີໂທ:</label>
                  <input type="number" class="input" v-model="phoneno" />
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">ປະສົບການ (ຖ້າມີ):</label>
                  <b-input
                    maxlength="500"
                    v-model.trim="experience"
                    type="textarea"
                    placeholder="ປະສົບການ"
                  ></b-input>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <button
                    class="button is-primary is-fullwidth"
                    @click="doRegister"
                  >
                    ສະໝັກ
                  </button>
                </div>
              </div>
              <!-- <div class="field">
                <div class="control">
                  <button
                    class="button is-info is-fullwidth"
                    @click="goRegister"
                  >
                    ລົງທະບຽນ
                  </button>
                </div>
              </div> -->
              <div class="field">
                <b-field class="login-fail">
                  {{ this.errorMessage }}
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import restAPI from "../RestAPI";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  name: "Login",
  data() {
    return {
      fullname: "",
      gender: "",
      genderlist: [{"ID":"1","TITLE":"ຍິງ"},{"ID":"2","TITLE":"ຊາຍ"}],
      section: "",
      year: "",
      phoneno: "",
      experience: "",
      errorMessage: null,
      role: null
    };
  },
  methods: {
    doRegister() {
      // console.log("there....");
      this.errorMessage = null;
      if (!this.validationForm()) {
        return;
      }
      const loadingComponent = this.$loading.open({});

      var params = {
        fullname: this.fullname,
        gender: this.gender.TITLE,
        section: this.section,
        year: this.year,
        phoneno: this.phoneno,
        experience: this.experience
      };
      console.log("req:" + JSON.stringify(params));
      // loadingComponent.close();
      restAPI
        .internstudentregister(params)
        .then(res => {
          console.log("Res: " + JSON.stringify(res.data))
          if (typeof res.data.result === "string") {
            console.log("error-: " + JSON.stringify(res.data));
            this.errorMessage = JSON.stringify(res.data);
            return;
          }
          
          if (res.data.result==1) {
            this.$swal("ລົງທະບຽນ ສຳເລັດ!", "", "success");
            setTimeout(() => {
              window.location.href = "https://agrilao.com/internstudent";
            }, 2000);
            
           
          }else if(res.data.result == 0){
            this.errorMessage = "ເບີໂທຊ້ຳ";
            return false;
          }
          else {
            console.log("res: " + JSON.stringify(res.data))
            this.errorMessage = "ລົງທະບຽນບໍ່ສຳເລັດ";
            return false;
          }
        })
        .catch(err => {
          if (err.response) {
            console.log("err-: " + err.response);
          } else {
            console.log("err+:" + err);
          }
        })
        .then(() => {
          loadingComponent.close();
        });
    },

    validationForm() {
      if (
        this.fullname === null ||
        this.fullname.length == 0 ||
        this.gender.ID === null ||
        this.gender.length === 0 ||
        this.section === null ||
        this.section.length == 0 ||
        this.year === null ||
        this.year.length == 0 ||
        this.phoneno === null ||
        this.phoneno.length < 8 
      ) {
        this.errorMessage = "ປະກອບຂໍ້ມູນໃຫ້ຄົບຖ້ວນ ໃຫ້ຄົບ!";
        return false;
      }
      return true;
    }
  },
};
</script>

<style scoped>
#login-box {
  padding: 20px;
  margin-top: 100px;
}
.login-fail{
  color:red;
}
</style>
